module.exports = __webpack_public_path__ + "img/io-8.31df0c41.png";